const COMPANION_API_URL = process.env.REACT_APP_COMPANION_API_URL;

export async function submitBookingFeedback({ appointmentId, companyId, rating, comment }) {
  if (!COMPANION_API_URL) {
    throw new Error('Companion API is not configured.');
  }

  const res = await fetch(`${COMPANION_API_URL}/api/booking-feedback/public`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      appointmentId,
      companyId,
      rating,
      comment,
      source: 'cp-redesign',
    }),
  });

  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.error || 'Could not submit your feedback.');
  }
  return data;
}

export function surveyStorageKey(appointmentId) {
  return `cp_booking_survey_${appointmentId}`;
}

export function getSurveyDismissState(appointmentId) {
  try {
    return localStorage.getItem(surveyStorageKey(appointmentId));
  } catch {
    return null;
  }
}

export function setSurveyDismissState(appointmentId, state) {
  try {
    localStorage.setItem(surveyStorageKey(appointmentId), state);
  } catch {
    // ignore quota / private mode
  }
}
